import React from "react";

export default function Privatlivspolitik() {
  return (
    <div className="bg-[#F7F3EC] min-h-screen" data-testid="privatlivspolitik-page">
      <section className="py-16 md:py-24 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="label-tag mb-4">Juridisk</div>
        <h1 className="font-heading text-4xl md:text-5xl text-graphite mb-10 leading-tight">Privatlivspolitik.</h1>
        <div className="prose prose-lg max-w-none text-graphite/85 leading-relaxed space-y-6">
          <p>
            Mahasa behandler personoplysninger om dig i overensstemmelse med Databeskyttelsesforordningen (GDPR) og den danske databeskyttelseslov. Denne politik beskriver, hvordan vi indsamler, bruger og beskytter dine oplysninger.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">1. Dataansvarlig</h2>
          <p>
            Mahasa er dataansvarlig for behandlingen af de personoplysninger, vi har modtaget om dig. Du kan kontakte os via informationerne på vores kontaktside.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">2. Hvilke oplysninger vi indsamler</h2>
          <p>
            Når du henvender dig til os via kontaktformularen, booker en bil eller indgår en aftale med os, indsamler vi typisk:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Navn og kontaktinformation (e-mail og telefonnummer)</li>
            <li>Adresse (ved leje- eller købsaftaler)</li>
            <li>Kørekortoplysninger (ved biludlejning)</li>
            <li>CPR- og betalingsinformationer (når lovgivningen kræver det)</li>
            <li>Beskeder du selv sender til os</li>
          </ul>

          <h2 className="font-heading text-2xl text-graphite pt-6">3. Formål</h2>
          <p>
            Dine oplysninger anvendes til at besvare henvendelser, levere services (udlejning og salg af biler), opfylde aftaler og overholde lovkrav (bl.a. bogføring og skat).
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">4. Opbevaring</h2>
          <p>
            Vi opbevarer dine oplysninger så længe det er nødvendigt for det formål, de blev indsamlet til — typisk 5 år efter en aftales ophør i henhold til bogføringsloven.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">5. Videregivelse</h2>
          <p>
            Vi videregiver ikke dine oplysninger til tredjepart udover når det er nødvendigt for at opfylde aftalen (fx forsikring) eller når lovgivningen kræver det.
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">6. Dine rettigheder</h2>
          <p>
            Du har ret til indsigt, berigtigelse, sletning, begrænsning, dataportabilitet og indsigelse. Du kan også klage til Datatilsynet (datatilsynet.dk).
          </p>

          <h2 className="font-heading text-2xl text-graphite pt-6">7. Kontakt</h2>
          <p>
            Har du spørgsmål til vores behandling af dine oplysninger, eller ønsker du at gøre brug af dine rettigheder, så kontakt os via vores kontaktside.
          </p>

          <p className="text-sm text-graphite/55 pt-8 border-t border-[#E5DED1]">Senest opdateret: {new Date().toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" })}</p>
        </div>
      </section>
    </div>
  );
}
